<template>
<div>

    <v-navigation-drawer  id="admin-drawer" v-model="drawer" :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'" disable-resize-watcher :right="$vuetify.rtl" :src="barImage" app width="210" v-bind="$attrs">
        <v-btn fab x-small absolute text right v-if="drawer" @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : setDrawer(!drawer)" v-tippy title="Ocultar Barra Lateral">
            <v-icon x-small gray--text>mdi-arrow-expand-left</v-icon>
        </v-btn>

        <template v-slot:img="props">
            <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
        </template>
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="text-uppercase font-weight-regular display-2">
                    <span class="logo-normal">
                        <img v-if=" (sa31==0 && sa24==0 &&  manifiesto ==0 && !soloSoluciona) || id_cliente==0" src="/static/logo_blanco.png" height="32" alt="proControl" />
                        <img v-if=" manifiesto == 1 && id_cliente > 0" src="/static/emanifiesto.png" height="32" alt="eManifiesto" />
                        <img v-if="( sa31==1 || soloSoluciona) && id_cliente > 0 " src="/static/logosa31N.png" height="32" alt="sa31" />
                        <img v-if="( sa24==1 || soloSoluciona24) && id_cliente > 0 " src="/static/logosa24B.png" height="32" alt="sa24" />
                    </span>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list three-line style="margin-top:-30px" v-if="!is_consignatario">
            <v-menu offset-x transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <v-list-item v-bind="attrs" v-on="on">
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-black">{{nombre_usuario}}</v-list-item-title>
                            <v-list-item-subtitle v-if="es_cliente" class="font-weight-black">{{rfc}}</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="es_cliente" class="caption">{{razon}}</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="es_grupo  && id_cliente ==0 " class="caption">{{$local_storage.get("nombre_grupo")}}</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="es_grupo && !es_transportista && !es_agente  && id_cliente ==0 " class="caption">Grupo</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="es_transportista && id_cliente ==0 " class="caption">Transportista</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="es_agente  && id_cliente ==0 " class="caption">Agencia Aduanal</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="!es_grupo  && !es_cliente" class="caption">{{$local_storage.get("tipo_usuario")}}</v-list-item-subtitle>


                        </v-list-item-content>

                        <v-list-item-action v-if='verflecha'>
                            <v-icon color="theme--light">mdi-arrow-right</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </template>

                <v-list :tile="false" flat nav v-if='verflecha'>
                    <template>
                        <app-bar-item to="/listaclientes" v-if="varios_clientes">
                            <v-icon>mdi-circle-small</v-icon>
                            <v-list-item-title >Lista de clientes</v-list-item-title>
                        </app-bar-item>
                        <app-bar-item to="/listagrupos" v-if='$local_storage.get("tipo_usuario") == "Super Usuario"'>
                            <v-icon>mdi-circle-small</v-icon>
                            <v-list-item-title>Lista de grupos</v-list-item-title>
                        </app-bar-item>
                        <app-bar-item v-if='$local_storage.get("tipo_usuario") == "Super Usuario" || $local_storage.get("tipo_usuario") == "Grupo" '>
                            <v-icon>mdi-circle-small</v-icon>
                            <v-list-item-title @click="toadmin" >Panel de Administrador</v-list-item-title>
                        </app-bar-item>
                        <app-bar-item  to="/clientes/domicilio" v-if="id_cliente>0 && (valida_permiso('Administracion.datosgenerales') || soloSoluciona) ">
                            <v-icon>mdi-circle-small</v-icon>
                            <v-list-item-title>Datos Generales</v-list-item-title>
                        </app-bar-item>

                         <app-bar-item  to="/clientes/certificados"  v-if="id_cliente>0  && (valida_permiso('Administracion.sellos') || valida_permiso('EmanifiestoMV.sellos') || valida_permiso('EmanifiestoMV.Logistico.Sellos') || soluciona) && !soloDataStage ">
                            <v-icon>mdi-circle-small</v-icon>
                            <v-list-item-title>Sellos Digitales</v-list-item-title>
                        </app-bar-item>


                       <!--     <app-bar-item  to="#" v-if="valida_permiso('Administracion.preferencias') && id_cliente>0 && !soloDataStage" disabled>
                                    <v-icon x-small>mdi-check-decagram</v-icon>
                                    <v-list-item-title class="font-weight-thin">&nbsp; Control de Preferencias</v-list-item-title>
                                </app-bar-item>  -->
                    </template>
                </v-list>
            </v-menu>
        </v-list>
        <div style="margin-left:15px; margin-right:15px">
            <v-btn x-small v-if=" soluciona24 && !soloSoluciona24" :color="sa24_color" @click=" ver_sa24()" :outlined="sa24==false" style="width:165px;">
                 <b>SolucionA24</b>
            </v-btn>
        </div>
        <div style="margin-left:15px; margin-right:15px; margin-top:5px">
            <v-btn x-small v-if=" soluciona && !soloSoluciona" :color="sa31_color" @click=" ver_sa31()" :outlined="sa31==false" style="width:165px;">
                 <b>SolucionA31</b>
            </v-btn>
        </div>
        <div style="margin-left:15px; margin-right:15px; margin-top:5px">
            <v-btn x-small v-if="premiso_trafico && !soloTrafico" :color="trafico_color" @click="ver_trafico" :outlined="trafico==false" style="width:165px;">
                 <b>Gestión de Embarques</b>
            </v-btn>
        </div>

         <div style="margin-left:15px; margin-right:15px; margin-top:5px">
            <v-btn x-small v-if="id_cliente > 0  &&  eCosting && !soloEcosting" :color="costing_color"  @click="ver_costing" :outlined="costing == false" style="width:165px;">
                <b>eCosting</b>
            </v-btn>
        </div>
        <div style="margin-left:15px; margin-right:15px; margin-top:5px">
            <v-btn x-small v-if="id_cliente > 0  &&  eManifiesto && !soloEmanifiesto" :color="manifiesto_color"  @click="ver_manifiesto" :outlined="manifiesto == false" style="width:165px;">
                <b>EMANIFIESTO</b>
            </v-btn>
        </div>
         <v-divider v-if="id_cliente > 0 && soloTransmision" class="mb-1" />
        <div style="margin-left:15px; margin-right:15px; margin-top:5px;">
            <v-btn x-small v-if="id_cliente > 0 && soloTransmision" color="white" to="/transmision/covedetalles" outlined style="width:165px;">
                 <b>COVES</b>
            </v-btn>
        </div>
         <v-divider v-if="id_cliente > 0 && soloTransmision" class="mb-1" />
         <div style="margin-left:15px; margin-right:15px; margin-top:5px;">
            <v-btn x-small v-if="id_cliente > 0 && soloTransmision" color="white" to="/transmision/edocument" outlined style="width:165px;">
                 <b>EDOCUMENTS</b>
            </v-btn>
        </div>

        <div style="margin-left:15px; margin-right:15px; margin-top:5px;">
            <v-btn x-small v-if="(id_cliente > 0 && cartaporte  && !soloCartaPorte) || es_agente"  :color="carta_porte_color"  @click="ver_carta_porte" :outlined="carta_porte == false" style="width:165px;" >
                 <b>CARTA PORTE</b>
            </v-btn>
        </div>
         <v-divider v-if="id_cliente > 0 && soloTransmision && !is_consignatario  && !soloEcosting && !soloEmanifiesto && !soloCartaPorte && !soloSoluciona24" class="mb-1" />
         <div v-if="!is_consignatario && !soloEcosting && !soloEcosting && !soloEmanifiesto && !soloCartaPorte && !soloSoluciona24" style="margin-left:15px; margin-right:15px; margin-top:5px;">
            <v-btn x-small v-if="id_cliente > 0" color="white" to="/tigiews" outlined style="width:165px;">
                 <b>TIGIE</b>
            </v-btn>
        </div>

        <v-divider v-if="id_cliente > 0 && conAnalitics && (!soloDataStage || !soloTransmision) && !is_consignatario && !soloEcosting && !soloEmanifiesto && !soloCartaPorte" class="mb-1" />
        <glosas-cargadas v-if="id_cliente > 0  && (soloDataStage || dataStage || soloSoluciona || soluciona || soluciona24 || soloSoluciona24 )  && !soloTransmision && !is_consignatario && !soloEcosting && !soloEmanifiesto && no_agente_rece" />
        <glosasCargadasAA v-if="id_cliente == 0  && es_agente" />
        <v-divider v-if="id_cliente > 0 && conAnalitics && (!soloDataStage || !soloTransmision) && !is_consignatario && !soloEcosting && !soloEmanifiesto && !soloCartaPorte" class="mb-1" />
        <barrasProgresoAA v-if="id_cliente == 0  && es_agente" />
        <barras-progreso v-if="id_cliente > 0 && ((conAnalitics || soloSoluciona || soluciona ) && (!soloDataStage || !soloTransmision)) && !is_consignatario && !soloEcosting && !soloEmanifiesto" />
        <v-divider v-if="id_cliente > 0 && !soloEcosting && !soloEmanifiesto && !soloCartaPorte" class="mb-1" />

        <diario v-if="id_cliente > 0 && !is_consignatario && !soloEcosting && !soloEmanifiesto && !soloCartaPorte && !soloSoluciona24" />

        <v-divider v-if="id_cliente > 0 && !is_consignatario && !soloCartaPorte" class="mb-1" />
        <div class="container-fluid footer ">
            &copy; MxTransmite {{ new Date().getFullYear() }} -
            <a v-if="superusuario" style="color:#DF7205;" @click="dialog=true">
                ProControl v {{version}}
            </a>
            <a v-if="superusuario == false" style="color:#DF7205;">ProControl v {{version}}</a>
            <a href="https://power-devel.com" target="_blank">
                <v-icon color="blue" x-small title="Desarrollado por Power-Devel" v-tippy>mdi-wrench</v-icon>
            </a>

            <v-dialog v-model="dialog" width="800">

                <v-card>
                    <v-card-title class="headline grey lighten-2">
                        Notas de la Versión
                    </v-card-title>

                    <v-card-text>

                        <div v-for="item in notas" :key="item.id">
                            <h5>{{item.version}}</h5>
                            <div v-html="item.cambios" />
                        </div>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="dialog = false">
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-navigation-drawer>
<p/>
<p/>
</div>
</template>

<style scoped>
.footer {
    text-align: left;
    position: fixed;
    bottom: 0;
    height: 15px;

    color: #0E4D78;
    background-color: #f5f5f5;
    z-index: 100000;
    font-size: 7pt;
}
</style>

<script>
// Utilities
import {
    mapState,
    mapMutations
} from "vuex";
import {
    VHover,
    VListItem
} from "vuetify/lib";
import glosasCargadas from "@/components/glosasCargadas.vue";
import glosasCargadasAA from "@/components/glosasCargadasAA.vue";
import barrasProgreso from "@/components/barrasProgreso.vue";
import barrasProgresoAA from "@/components/barrasProgresoAA.vue";
import diario from "@/components/DiarioOficial.vue";
import axios from "axios";
import moment from "moment";

export default {
    name: "DrawerAdmin",
    components: {
        glosasCargadas,
        glosasCargadasAA,
        barrasProgreso,
        barrasProgresoAA,
        diario,
        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },
    props: {
        expandOnHover: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        dialog: false,
        dialog_info:false,
        version: 0.00,
        notas: [],
        fab: false,
        trafico: false,
        costing: false,
        sa31: false,
        sa24: false,
        manifiesto: false,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        nombre_usuario: "",
        varios_clientes: false,
        fav: true,
        menu: false,
        message: false,
        hints: true,
        profile: [{
                title: "Lista de Empresas",
                to: "listaclientes"
            },
            {
                title: "Panel Administrador",
                to: "admin"
            }
        ],

    }),

    computed: {
        ...mapState(["barColor", "barImage", "drawer"]),
        drawer: {
            get() {
                return this.$store.state.drawer;
            },
            set(val) {
                this.$store.commit("SET_DRAWER", val);
            }
        },
        verflecha(){
             return this.varios_clientes ||
                    this.$local_storage.get("tipo_usuario") == "Super Usuario" ||
                    this.$local_storage.get("tipo_usuario") == "Grupo" ||
                    this.valida_permiso('Administracion.datosgenerales')  ||
                    this.valida_permiso('Administracion.sellos') ||
                    this.valida_permiso('EmanifiestoMV.sellos') ||
                    this.valida_permiso('EmanifiestoMV.Logistico.Sellos') ;
        },
        superusuario() {
            return this.$local_storage.get("tipo_usuario") == "Super Usuario";
        },
        es_transportista() {
            return this.$local_storage.get("es_transportista")==1 ;
        },
        es_agente() {
            return this.$local_storage.get("es_agente")==1 && this.$local_storage.get("id_grupo")>0 ;
        },
        computedItems() {
            return this.items.map(this.mapItem);
        },
        soloCartaPorte() {
            return this.$local_storage.get("soloCartaPorte") == 100 ;
        },
        cartaporte() {
            return  this.$local_storage.get("Modulo13") == 100;
        },
        soluciona() {
            return  (this.$local_storage.get("Modulo15") == 100 || this.$local_storage.get("Modulo16") == 100) &&  this.$local_storage.get("id_cliente") > 0;
        },
        soluciona24() {
            return  (this.$local_storage.get("Modulo18") == 100 ) &&  this.$local_storage.get("id_cliente") > 0;
        },
        no_agente_rece() {
            return this.$local_storage.get("perfil_grupo") != 66;
        },

        trafico_color() {
            if (this.$store.state.trafico == 1) {
                return "secondary";
            } else {
                return "white";
            }
        },
        sa31_color() {
            if (this.$store.state.sa31 == 1) {
                return "secondary";
            } else {
                return "white";
            }
        },
        sa24_color() {
            if (this.$store.state.sa24 == 1) {
                return "secondary";
            } else {
                return "white";
            }
        },
        costing_color() {
            if (this.$store.state.costing == 1) {
                return "secondary";
            } else {
                return "white";
            }
        },
        manifiesto_color() {
            if (this.$store.state.emanifiesto == 1) {
                return "secondary";
            } else {
                return "white";
            }
        },
        carta_porte_color() {
            if (this.$store.state.carta_porte == 1) {
                return "secondary";
            } else {
                return "white";
            }
        },
        is_consignatario(){
            return this.$local_storage.get("perfil_grupo") == 43 ;
        },
        soloDataStage() {
            return this.$local_storage.get("DATA.STAGE.bitacora") == 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            &&  this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100
            && this.$local_storage.get("EmanifiestoMV.bitacora") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("Modulo15") != 100
            && this.$local_storage.get("Modulo16") != 100 && this.$local_storage.get("Modulo18") != 100;
        },
        soloTransmision() {
            return this.$local_storage.get("VUCEM.Transmision.nuevo.cove") == 100 && this.$local_storage.get("DATA.STAGE.bitacora") != 100
            &&  this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100
            && this.$local_storage.get("EmanifiestoMV.bitacora") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("Modulo15") != 100
            && this.$local_storage.get("Modulo16") != 100 && this.$local_storage.get("Modulo18") != 100;
        },
        soloEcosting() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            && this.$local_storage.get("EmanifiestoMV.bitacora") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100
            &&  this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100 && this.$local_storage.get("Modulo15") != 100
            && this.$local_storage.get("Modulo16") != 100 && this.$local_storage.get("Modulo18") != 100;
        },
        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100
            && this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100
            && (this.$local_storage.get("EmanifiestoMV.bitacora") == 100 ) && this.$local_storage.get("Modulo15") != 100
            && this.$local_storage.get("Modulo16") != 100 && this.$local_storage.get("Modulo18") != 100;
        },
        soloTrafico() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
            this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 &&
             (this.$local_storage.get("EmanifiestoMV.bitacora") != 100 ) && this.$local_storage.get( "Logistica.nuevoregistro" ) == 100
             && this.$local_storage.get("Modulo15") != 100 && this.$local_storage.get("Modulo16") != 100 && this.$local_storage.get("Modulo18") != 100;
        },
        soloSoluciona() {
            return this.$local_storage.get("soloSA31") == 100 ;
        },
        soloSoluciona24() {
            return this.$local_storage.get("soloSA24") == 100 ;
        },

        eManifiesto() {
            return this.$local_storage.get("EmanifiestoMV.bitacora") == 100;
        },
        eCosting() {
            return this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100 ;
        },
        conAnalitics(){
            return this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100 ;
        },
        dataStage(){
            return this.$local_storage.get("DATA.STAGE.bitacora") == 100;
        },
        premiso_trafico() {
            return (
                this.$local_storage.get(
                    "Logistica.nuevoregistro"
                ) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        id_cliente() {
            return this.$local_storage.get("id_cliente");
        },
        es_cliente() {
            return this.$local_storage.get("id_cliente") > 0;
        },
        es_grupo() {
            return this.$local_storage.get("id_grupo") > 0 &&  this.$local_storage.get("id_cliente") == 0;
        }
    },

    watch: {
        "$vuetify.breakpoint.smAndDown"(val) {
            this.$emit("update:expandOnHover", !val);
        }
    },
     created() {
        if(this.soloTrafico){
            this.$store.state.trafico = 1;
            this.trafico = 1;
            this.$local_storage.set("trafico", 1)
        }else{
            this.$store.state.trafico = this.$local_storage.get("trafico");
            this.trafico = this.$local_storage.get("trafico");
        }

        this.$store.state.costing = this.$local_storage.get("costing");
        this.costing = this.$local_storage.get("costing");
        this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
        this.manifiesto = this.$local_storage.get("emanifiesto");
        this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
        this.carta_porte = this.$local_storage.get("carta_porte");
        this.$store.state.sa31 = this.$local_storage.get("sa31");
        this.sa31 = this.$local_storage.get("sa31");
        this.$store.state.sa24 = this.$local_storage.get("sa24");
        this.sa24 = this.$local_storage.get("sa24");
        this.getVersion();



    },
     mounted() {


        if(!this.is_consignatario)
            this.carga_datos();

       if(this.soloTrafico && this.$local_storage.get("id_cliente") > 0 ){

            this.$local_storage.set("trafico", 1);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("costing", 0);
            this.$local_storage.set("sa31", 0);
            this.$local_storage.set("sa24", 0);
            this.$store.state.trafico = this.$local_storage.get("trafico");
            this.$store.state.costing = this.$local_storage.get("costing");
            this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
            this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
            this.$store.state.sa31 = this.$local_storage.get("sa31");
            this.trafico = this.$local_storage.get("trafico");
            this.costing = this.$local_storage.get("costing");
            this.manifiesto = this.$local_storage.get("emanifiesto");
            this.carta_porte = this.$local_storage.get("carta_porte");
            this.sa31 = this.$local_storage.get("sa31");
            this.sa24 = this.$local_storage.get("sa24");
            this.$router.push("/trafico_index").catch(()=>{});
        }
        if(this.soloEcosting && this.$local_storage.get("id_cliente") > 0 ){

                    this.$local_storage.set("trafico", 0);
                    this.$local_storage.set("emanifiesto", 0);
                    this.$local_storage.set("carta_porte", 0);
                    this.$local_storage.set("costing", 1);
                    this.$local_storage.set("sa31", 0);
                    this.$local_storage.set("sa24", 0);
                    this.$store.state.trafico = this.$local_storage.get("trafico");
                    this.$store.state.costing = this.$local_storage.get("costing");
                    this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
                     this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
                     this.$store.state.sa31 = this.$local_storage.get("sa31");
                    this.trafico = this.$local_storage.get("trafico");
                    this.costing = this.$local_storage.get("costing");
                    this.manifiesto = this.$local_storage.get("emanifiesto");
                    this.carta_porte = this.$local_storage.get("carta_porte");
                    this.sa31 = this.$local_storage.get("sa31");
                    this.sa24 = this.$local_storage.get("sa24");
                    this.$router.push("/facturastransito").catch(()=>{});
        }
        if(this.soloEmanifiesto && this.$local_storage.get("id_cliente") > 0 ){

                    this.$local_storage.set("trafico", 0);
                    this.$local_storage.set("costing", 0);
                    this.$local_storage.set("carta_porte", 0);
                    this.$local_storage.set("emanifiesto", 1);
                    this.$local_storage.set("sa31", 0);
                    this.$local_storage.set("sa24", 0);
                    this.$store.state.trafico = this.$local_storage.get("trafico");
                    this.$store.state.costing = this.$local_storage.get("costing");
                    this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
                    this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
                    this.$store.state.sa31 = this.$local_storage.get("sa31");
                    this.trafico = this.$local_storage.get("trafico");
                    this.costing = this.$local_storage.get("costing");
                    this.manifiesto = this.$local_storage.get("emanifiesto");
                    this.carta_porte = this.$local_storage.get("carta_porte");
                    this.sa31 = this.$local_storage.get("sa31");
                    this.sa24 = this.$local_storage.get("sa24");
                    this.$router.push("/manifestacion/transmitir").catch(()=>{});
        }
        if(this.$local_storage.get("soloCartaPorte") > 0 && this.$local_storage.get("id_cliente") > 0 ){

                    this.$local_storage.set("trafico", 0);
                    this.$local_storage.set("costing", 0);
                    this.$local_storage.set("carta_porte", 1);
                    this.$local_storage.set("emanifiesto", 0);
                    this.$local_storage.set("sa31", 0);
                    this.$local_storage.set("sa24", 0);
                    this.$store.state.trafico = this.$local_storage.get("trafico");
                    this.$store.state.costing = this.$local_storage.get("costing");
                    this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
                    this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
                    this.$store.state.sa31 = this.$local_storage.get("sa31");
                    this.trafico = this.$local_storage.get("trafico");
                    this.costing = this.$local_storage.get("costing");
                    this.manifiesto = this.$local_storage.get("emanifiesto");
                    this.carta_porte = this.$local_storage.get("carta_porte");
                    this.sa31 = this.$local_storage.get("sa31");
                    this.sa24 = this.$local_storage.get("sa24");
                    this.$router.push("/index").catch(()=>{});
        }
        if(this.soloSoluciona && this.$local_storage.get("id_cliente") > 0 ){

            this.$local_storage.set("trafico", 0);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("costing", 0);
            this.$local_storage.set("sa31", 1);
            this.$local_storage.set("sa24", 0);
            this.$store.state.trafico = this.$local_storage.get("trafico");
            this.$store.state.costing = this.$local_storage.get("costing");
            this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
            this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
            this.$store.state.sa31 = this.$local_storage.get("sa31");
            this.trafico = this.$local_storage.get("trafico");
            this.costing = this.$local_storage.get("costing");
            this.manifiesto = this.$local_storage.get("emanifiesto");
            this.carta_porte = this.$local_storage.get("carta_porte");
            this.sa31 = this.$local_storage.get("sa31");
            this.sa24 = this.$local_storage.get("sa24");
            this.$router.push("/indexsa31").catch(()=>{});
            }
    if(this.soloSoluciona24 && this.$local_storage.get("id_cliente") > 0 ){

                this.$local_storage.set("trafico", 0);
                this.$local_storage.set("emanifiesto", 0);
                this.$local_storage.set("carta_porte", 0);
                this.$local_storage.set("costing", 0);
                this.$local_storage.set("sa31", 0);
                this.$local_storage.set("sa24", 1);
                this.$store.state.trafico = this.$local_storage.get("trafico");
                this.$store.state.costing = this.$local_storage.get("costing");
                this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
                this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
                this.$store.state.sa31 = this.$local_storage.get("sa31");
                this.trafico = this.$local_storage.get("trafico");
                this.costing = this.$local_storage.get("costing");
                this.manifiesto = this.$local_storage.get("emanifiesto");
                this.carta_porte = this.$local_storage.get("carta_porte");
                this.sa31 = this.$local_storage.get("sa31");
                this.sa24 = this.$local_storage.get("sa24");
                this.$router.push("/indexsa24").catch(()=>{});
                }

    },
    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },

        mapItem(item) {
            return {
                ...item,
                children: item.children ? item.children.map(this.mapItem) : undefined,
                title: this.$t(item.title)
            };
        },
        mostrarmenu: function (val) {
            //Se actualiza la variable store.state.datetime para forzar a recargar el componente de AppBar.vue
            //Esta variable se manda llamar en el archivo App.vue
            this.$store.state.datetime = moment(new Date()).format("x"); //Unix timestamp
        },
        toadmin(){
            this.$local_storage.set("soloCartaPorte", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$store.state.carta_porte = 0;
            this.$local_storage.set("id_cliente", 0);
            this.$local_storage.set("cambio_cliente", true);
            this.$local_storage.set("rfc", "");
            this.$local_storage.set("razon", "");
            this.$local_storage.set("soloSA31", 0);
            this.$local_storage.set('sa31', 0);
            this.$local_storage.set('sa24', 0);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("rfc_agencia", "");
            this.$local_storage.set("es_agencia", "0");

            if (this.$local_storage.get("tipo_usuario") == "Super Usuario" || this.$local_storage.get("tipo_usuario") == "Soporte") {
                this.$local_storage.set("panel_grupo", 0);
                this.$local_storage.set("es_transportista", 0);
                this.$local_storage.set("es_agente", 0);
                this.$local_storage.set("rfc_grupo", "");
                this.$local_storage.set("nombre_grupo", "");
                this.$local_storage.set("id_grupo", 0);
            }
            if(this.$local_storage.get("padre_id_grupo")> 0){
                this.$local_storage.set("panel_grupo", this.$local_storage.get("padre_panel_grupo"));
                this.$local_storage.set("es_transportista", this.$local_storage.get("padre_es_transportista"));
                this.$local_storage.set("es_agente", this.$local_storage.get("padre_es_agente"));
                this.$local_storage.set("rfc_grupo", this.$local_storage.get("padre_rfc_grupo"));
                this.$local_storage.set("nombre_grupo", this.$local_storage.get("padre_nombre_grupo"));
                this.$local_storage.set("id_grupo", this.$local_storage.get("padre_id_grupo"));
            }
        //    if(this.$local_storage.get("id_grupo" ) > 0){
                this.$local_storage.set("padre_panel_grupo", this.$local_storage.get("panel_grupo"));
                this.$local_storage.set("padre_es_transportista", this.$local_storage.get("es_transportista"));
                this.$local_storage.set("padre_es_agente", this.$local_storage.get("es_agente"));
                this.$local_storage.set("padre_rfc_grupo", this.$local_storage.get("rfc_grupo"));
                this.$local_storage.set("padre_nombre_grupo", this.$local_storage.get("nombre_grupo"));
                this.$local_storage.set("padre_id_grupo", this.$local_storage.get("id_grupo"));
          //  }


            this.$user.set({id_cliente: 0 });
            this.$store.state.id_cliente = -1;
            if (this.$local_storage.get("tipo_usuario") == "Cliente") {
                delete this.options.headings["fecha_ingreso"];
                delete this.options.headings["fecha_vencimiento"];
                var keyFI = 0;
                var keyFV = 0;
                for (var k in this.columns) {
                    if (this.columns[k] == "fecha_ingreso") keyFI = k;
                    if (this.columns[k] == "fecha_vencimiento") keyFV = k;
                }
                if (keyFI > 0) delete this.columns[keyFI];
                if (keyFV > 0) delete this.columns[keyFV];
            }
            this.mostrarmenu()
            this.$router.push("/admin").catch(()=>{});
           // window.location.reload();

        },
        ver_trafico() {
            this.$local_storage.set("costing", 0);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("sa31", 0);
            this.$local_storage.set("sa24", 0);

            this.$store.state.costing = this.$local_storage.get("costing");
            this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
            this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
            this.$store.state.sa31 = this.$local_storage.get("sa31");

            this.costing = this.$local_storage.get("costing");
            this.manifiesto = this.$local_storage.get("emanifiesto");
            this.carta_porte = this.$local_storage.get("carta_porte");
            this.sa31 = this.$local_storage.get("sa31");
            this.$store.state.sa24 = this.$local_storage.get("sa24");
            this.sa24 = this.$local_storage.get("sa24");

            if (this.$local_storage.get("trafico") == 1){
                this.$local_storage.set("trafico", 0);
                this.$store.state.trafico = this.$local_storage.get("trafico");
                this.trafico = this.$local_storage.get("trafico");
                this.$router.push("/home").catch(()=>{});
            }
            else {
                this.$local_storage.set("trafico", 1);
                  this.$store.state.trafico = this.$local_storage.get("trafico");
                this.trafico = this.$local_storage.get("trafico");
                this.$router.push("/trafico_index").catch(()=>{});
            }


        },
        ver_sa31() {

            this.$local_storage.set("costing", 0);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("trafico", 0);
            this.$local_storage.set("sa24", 0);

            this.$store.state.costing = this.$local_storage.get("costing");
            this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
            this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
            this.$store.state.trafico = this.$local_storage.get("trafico");

            this.costing = this.$local_storage.get("costing");
            this.manifiesto = this.$local_storage.get("emanifiesto");
            this.carta_porte = this.$local_storage.get("carta_porte");
            this.trafico = this.$local_storage.get("trafico");
            this.$store.state.sa24 = this.$local_storage.get("sa24");
            this.sa24 = this.$local_storage.get("sa24");

            if (this.$local_storage.get("sa31") == 1){
                this.$local_storage.set("sa31", 0);
                this.$store.state.sa31 = this.$local_storage.get("sa31");
                this.sa31 = this.$local_storage.get("sa31");
                this.$router.push("/home").catch(()=>{});
            }
            else {
                this.dialog_info = true;
                this.$local_storage.set("sa31", 1);
                this.$store.state.sa31 = this.$local_storage.get("sa31");
                this.sa31 = this.$local_storage.get("sa31");
                this.$local_storage.set("verSA31", 1);
                this.$router.push("/indexsa31").catch(()=>{});


            }


        },
        ver_sa24() {

            this.$local_storage.set("costing", 0);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("trafico", 0);
            this.$local_storage.set("sa31", 0);

            this.$store.state.costing = this.$local_storage.get("costing");
            this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
            this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
            this.$store.state.trafico = this.$local_storage.get("trafico");


            this.costing = this.$local_storage.get("costing");
            this.manifiesto = this.$local_storage.get("emanifiesto");
            this.carta_porte = this.$local_storage.get("carta_porte");
            this.trafico = this.$local_storage.get("trafico");
            this.$store.state.sa31 = this.$local_storage.get("sa31");
            this.sa31 = this.$local_storage.get("sa31");

            if (this.$local_storage.get("sa24") == 1){
                this.$local_storage.set("sa24", 0);
                this.$store.state.sa24 = this.$local_storage.get("sa24");
                this.sa24 = this.$local_storage.get("sa24");
                this.$router.push("/home").catch(()=>{});
            }
            else {
                this.dialog_info = true;
                this.$local_storage.set("sa24", 1);
                this.$store.state.sa24 = this.$local_storage.get("sa24");
                this.sa24 = this.$local_storage.get("sa24");
                this.$local_storage.set("verSA24", 1);
                this.$router.push("/indexsa24").catch(()=>{});


            }


        },
        ver_costing() {
            this.$local_storage.set("trafico", 0);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("sa31", 0);
            this.$local_storage.set("sa24", 0);

            this.$store.state.trafico = this.$local_storage.get("trafico");
            this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
            this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
            this.$store.state.sa31 = this.$local_storage.get("sa31");

            this.trafico = this.$local_storage.get("trafico");
            this.carta_porte = this.$local_storage.get("carta_porte");
            this.manifiesto = this.$local_storage.get("emanifiesto");
            this.sa31 = this.$local_storage.get("sa31");
            this.$store.state.sa24 = this.$local_storage.get("sa24");
            this.sa24 = this.$local_storage.get("sa24");

            if (this.$local_storage.get("costing") == 1){
                this.$local_storage.set("costing", 0);
                this.$store.state.costing = this.$local_storage.get("costing");
                 this.costing = this.$local_storage.get("costing");
                this.$router.push("/home").catch(()=>{});
            }
            else {
                this.$local_storage.set("costing", 1);
                this.$store.state.costing = this.$local_storage.get("costing");
                 this.costing = this.$local_storage.get("costing");
                this.$router.push("/facturastransito").catch(()=>{});

            }


        },
        ver_manifiesto() {
            this.$local_storage.set("trafico", 0);
            this.$local_storage.set("costing", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("sa31", 0);
            this.$local_storage.set("sa24", 0);

            if (this.$local_storage.get("emanifiesto") == 1){
                this.$local_storage.set("emanifiesto", 0);
                this.$router.push("/home").catch(()=>{});
            }
            else {
                this.$local_storage.set("emanifiesto", 1);
                this.$router.push("/manifestacion/transmitir").catch(()=>{});

            }

            this.$store.state.trafico = this.$local_storage.get("trafico");
            this.$store.state.costing = this.$local_storage.get("costing");
            this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
            this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
            this.$store.state.sa31 = this.$local_storage.get("sa31");

            this.trafico = this.$local_storage.get("trafico");
            this.costing = this.$local_storage.get("costing");
            this.manifiesto = this.$local_storage.get("emanifiesto");
            this.carta_porte = this.$local_storage.get("carta_porte");
            this.sa31 = this.$local_storage.get("sa31");
            this.$store.state.sa24 = this.$local_storage.get("sa24");
            this.sa24 = this.$local_storage.get("sa24");
        },
         ver_carta_porte() {
            this.$local_storage.set("trafico", 0);
            this.$local_storage.set("costing", 0);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("sa31", 0);
            this.$local_storage.set("sa24", 0);

            if (this.$local_storage.get("carta_porte") == 1){
                this.$local_storage.set("carta_porte", 0);
                this.$router.push("/home").catch(()=>{});
            }
            else {
                this.$local_storage.set("carta_porte", 1);
                this.$router.push("/index").catch(()=>{});

            }

            this.$store.state.trafico = this.$local_storage.get("trafico");
            this.$store.state.costing = this.$local_storage.get("costing");
            this.$store.state.emanifiesto = this.$local_storage.get("emanifiesto");
            this.$store.state.carta_porte = this.$local_storage.get("carta_porte");
            this.$store.state.sa31 = this.$local_storage.get("sa31");

            this.trafico = this.$local_storage.get("trafico");
            this.costing = this.$local_storage.get("costing");
            this.manifiesto = this.$local_storage.get("emanifiesto");
            this.carta_porte = this.$local_storage.get("carta_porte");
            this.sa31 = this.$local_storage.get("sa31");
            this.$store.state.sa24 = this.$local_storage.get("sa24");
            this.sa24 = this.$local_storage.get("sa24");
        },
        carga_datos() {
            this.rfc = this.$local_storage.get("rfc");
            this.razon = this.$local_storage.get("razon");
            this.tipo_usuario = this.$local_storage.get("tipo_usuario");
            this.varios_clientes = this.$local_storage.get("varios_clientes") == 1;
            this.nombre_usuario = this.$local_storage.get("nombre_usuario");
        },
        listaclientes() {
            this.$local_storage.set("id_grupo", 0);
            this.$local_storage.set("id_cliente", 0);

            this.$router.push("/listaclientes").catch(()=>{});
        },
        backadmin() {
            this.$local_storage.set("id_cliente", 0);
            this.$local_storage.set("cambio_cliente", true);
            this.$local_storage.set("rfc", "");
            this.$local_storage.set("razon", "");
            this.$local_storage.set("id_grupo", 0);
            this.$local_storage.set("razon", "");
            this.$local_storage.set("rfc_agencia", "");
            this.$local_storage.set("es_agencia", "0");

            this.$user.set({
                id_cliente: 0
            });
            this.carga_datos();
            this.$store.state.id_cliente = -1;
            this.$router.push("/admin").catch(()=>{});
        },
        getVersion: function () {
            axios
                .get(this.$hostname + "configuracion/versiones/")
                .then(response => {

                    this.notas = response.data;
                    this.notas.sort(function (a, b) {
                        if (a['version'] < b['version'])
                            return 1;
                        else if (a['version'] > b['version'])
                            return -1;
                        return 0;
                    });
                    this.version = this.notas[0].version;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        genChildTarget(item, subItem) {
            if (subItem.href) return;
            if (subItem.component) {
                return {
                    name: subItem.component
                };
            }
            return {
                name: `${item.group}/${subItem.name}`
            };
        }
    }
};
</script>
<style scoped>
.v-menu__content .v-list--nav .v-list-item{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 5px;
  text-decoration: none;
}
.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
